import * as React from 'react';
import Portal from '@mui/material/Portal';
import { Box } from '@mui/system';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Portal": Portal, "@mui/system": { Box } } } });
export default ClientProvider;
